import React from 'react';
import {Link, Stack} from '@mui/material';
import {Link as RouterLink} from 'react-router';

/**
 * Clickable product title link component
 * @param {string} to - The link URL/path
 * @param {string} title - The product title
 * @param {number} flex - Flex value for the container
 * @param {React.ReactNode} [badge] - Optional inline badge rendered after the title text
 */
const ProductTitleLink = ({to, title, flex = 1, badge}) => {
    const handleClick = (e) => {
        e.stopPropagation();
    };

    return (
        <Stack flex={flex} direction="row" alignItems="center" minWidth={0} gap={0.75}>
            <Link
                component={RouterLink}
                to={to}
                variant="body1"
                onClick={handleClick}
                sx={{
                    display: 'block',
                    textAlign: 'left',
                    textDecoration: 'none',
                    color: 'primary.main',
                    maxWidth: '100%',
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                    cursor: 'pointer',
                }}
            >
                {title || 'Untitled'}
            </Link>
            {badge}
        </Stack>
    );
};

export default ProductTitleLink;
